define(function(require){
    'use strict';

    var Marionette = require('marionette');
    var LPTModel   = require('vendor/Backbone/LPTModel');
    var AppConfig = require('config/application');

    return LPTModel.extend({

    	urlRoot : function(){ return AppConfig.host + ''; },

        // url: '/server/?action=getAccountInfo',

        /**
         * LPTRACKERDEV-2430: тариф считается выбранным не только по флагу tariff_selected
         * (его ставит лишь смена тарифа самим клиентом), но и когда у аккаунта уже стоит
         * рабочий тариф — не тестовый 11186 и не стартовый тариф продукта.
         */
        isTariffSelected: function() {
            if (this.get('tariff_selected')) {
                return true;
            }

            var tariffId = parseInt(this.get('tariff_id'), 10) || 0;
            if (!tariffId || tariffId == 11186) {
                return false;
            }

            var product = window.app && window.app.Models.User && window.app.Models.User.get('product');
            var productTariffId = product ? (parseInt(product.tariff_id, 10) || 0) : 0;

            return tariffId != productTariffId;
        }
    });
});
